import { RBACAction, RBACModule } from '@numeo/types-core'
import { usePermissions } from '@/hooks/usePermissions'

/** Whether the user may assign loads (ONGOING_LOADS:EDIT, the board's own check). Without it the Assign actions are not drawn at all. */
export const useCanAssignLoads = (): boolean => usePermissions().hasPermission(RBACModule.ONGOING_LOADS, RBACAction.EDIT)
